import { getAuth, verifyBeforeUpdateEmail } from "firebase/auth";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const changeEmail = async (data) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error("User not authenticated");
    }

    await verifyBeforeUpdateEmail(user, data.newEmail);
};

export const useChangeEmail = (setReauthenticated) => {
    const navigate = useNavigate();

    return useMutation({
        mutationFn: changeEmail,
        retry: false,
        onSuccess: () => {
            toast.success("Email successfully sent");
            navigate(-1);
        },
        onError: (err) => {
            if (err.code === "auth/requires-recent-login") {
                setReauthenticated(false);
            } else {
                toast.error("Error sending email");
            }
        },
    });
};
